import { Box, styled } from '@mui/material';
export const PageLoadingWrapper = styled(Box)(({ theme }) => ({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
